import React, { useEffect, useRef, useState } from "react";
import ChatSideContent from "./ChatSideContent";
import { useLocation } from "react-router-dom";
// import socket from '../../../utils/socket';
import formatDate from "../../../utils/formatDate";
import apiClient from "../../../utils/apiClient";
import useToast from "../../../hooks/userToast";
import useUser from "../../../hooks/useUser";
import DoctorHeader from "../../../doctor/DoctorHeader";
import { profilePicture } from "../../imagepath";
import Sidebar from "../../Sidebar";
import { socket } from "../../../utils/socket";
import { SendOutlined } from "@mui/icons-material";
import { useUnreadMessages } from "../../context/UnreadMessagesProvider";
const Chat = () => {
  const [inputMessage, setInputMessage] = useState("");
  const { userID: userId, name } = useUser();
  const [messages, setMessages] = useState([]);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const selectedUserId = queryParams.get("userId");
  const userRole = queryParams.get("userRole");
  const userName = queryParams.get("userName");
  const { toastError } = useToast();
  const endOfMessagesRef = useRef(null);

  const { setUnreadCount } = useUnreadMessages();
  // Ensure that userRole is defined and not an empty string
  const isChatAvailable = userRole && userRole.trim() !== "";
  const scrollToBottom = () => {
    endOfMessagesRef.current?.scrollIntoView({ behavior: "smooth" });
  };
  useEffect(() => {
    scrollToBottom();
  }, [messages]);
  useEffect(() => {
    const fetchAllmessages = async () => {
      try {
        const allMessages = await apiClient.get(
          `/chat?senderId=${parseInt(userId)}&receiverId=${parseInt(
            selectedUserId
          )}`
        );
        setMessages(allMessages.data.Chats.data.messages.rows);
      } catch (err) {
        console.error(err?.response?.data);
        toastError("Error in fetching messages");
      }
    };
    if (selectedUserId) fetchAllmessages();
  }, [selectedUserId]);
  useEffect(() => {
    socket.emit("join-chat", userId);
    // console.log("socket join room-->", userId);
    return () => {
      socket.off("disconnect");
    };
  }, [socket]);
  useEffect(() => {
    const recieveMessage = async ({ data }) => {
      if (data.sender_id == selectedUserId) {
        // setUnreadCount((prev) => parseInt(prev) + 1);
        try {
          setUnreadCount((prev) => prev - 1);
          setMessages((prevMessages) => [...prevMessages, data]);
        } catch (error) {
          console.log("Error during updatin message status", error);
          toastError("Error in sending message");
        }
      }
    };
    socket.on("receive-message", recieveMessage);
    return () => {
      socket.off("receive-message", recieveMessage);
    };
  }, [socket, selectedUserId]);
  const sendMessage = async () => {
    if (inputMessage.trim() !== "") {
      try {
        const data = {
          sender_id: userId,
          receiver_id: selectedUserId,
          message: inputMessage,
          is_unread: 1,
        };
        const res = await apiClient.post("/chat/create", data);
        // console.log("response chat-->", res);
        const latestMessageTime = res?.data?.Chat?.created_date_time;
        const messageId = res?.data?.Chat?.id;
        // console.log("lastmessage time-->", latestMessageTime);
        let chatData = res.data.Chat;
        chatData.receiver = {
          name: userName,
        };
        chatData.sender = {
          name: name,
        };
        setMessages((prevMessages) => [...prevMessages, res.data.Chat]);
        socket.emit("send-message", { data, latestMessageTime, messageId });
        setInputMessage("");
      } catch (err) {
        console.error(err?.response?.data);
        toastError("Error in sending message");
        setInputMessage("");
      }
    }
  };
  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      sendMessage(event);
    }
  };
  return (
    <>
      <DoctorHeader />
      <Sidebar activeClassName="chat" />
      <div className="page-wrapper chat_manual">
        <div className="content">
          {/* Page Header */}
          <div className="page-header chat_size_box">
            <div className="row">
              <div className="col-sm-12"></div>
            </div>
          </div>
          {/* /Page Header */}
          <div className="row">
            <ChatSideContent />
            {isChatAvailable && (
              <div className="col-xl-8 col-md-8 chat_message">
                <div className="card chat-box">
                  <div className="chat-search-group">
                    <div className="chat-user-group mb-0 d-flex align-items-center">
                      <div className="img-users call-user">
                        <img
                          src={profilePicture}
                          alt="Profile"
                          className=" rounded-circle"
                        />
                      </div>
                      <div className="chat-users ms-3">
                        <div className="user-titles">
                          <h5>{userName}</h5>
                        </div>
                        <div className="user-text">
                          {userRole !== "undefined" && <p>{userRole}</p>}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Chat */}
                <div className="card chat-message-box message_box_chat">
                  <div className="card-body p-0">
                    <div className="chat-body">
                      <ul className="list-unstyled chat-message">
                        {messages?.map((chat, index) => (
                          <li
                            key={index}
                            className={`media d-flex ${
                              userId == chat?.sender_id ? "sent" : "received"
                            }`}
                          >
                            <div className="media-body flex-grow-1 ms-3">
                              <div className="msg-box">
                                <div className="message-sub-box">
                                  <h4>
                                    {userId == chat.sender_id
                                      ? "You"
                                      : chat?.sender?.name}
                                  </h4>
                                  <p>{chat?.message}</p>
                                  {chat.created_date_time && (
                                    <span>
                                      {formatDate(chat.created_date_time)}
                                    </span>
                                  )}
                                  {/* <span>{chat.created_date_time}</span> */}
                                </div>
                              </div>
                            </div>
                          </li>
                        ))}
                        {/* sent */}
                        <div ref={endOfMessagesRef} />
                      </ul>
                    </div>
                    {/*chat footer start*/}
                    <div className="chat-footer-box">
                      <div className="discussion-sent">
                        <div className="row gx-2">
                          <div className="col-lg-12">
                            <div className="footer-discussion">
                              <div className="inputgroups send_boxu">
                                <input
                                  onKeyDown={handleKeyDown}
                                  value={inputMessage}
                                  onChange={(e) =>
                                    setInputMessage(e.target.value)
                                  }
                                  type="text"
                                  placeholder="Type your Message here..."
                                  className="form-control"
                                />
                                <div className="send-chat position-icon comman-flex">
                                  <SendOutlined onClick={sendMessage} />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* Chat footer end */}
                  </div>
                </div>
                {/* /Chat */}
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Chat;
